import React from "react"
import styled from "styled-components"

const ScrollBox = styled.div`
overflow: scroll;
height: ${props => props.height}px
`
export default props => {

    return <ScrollBox height={props.height || window.screen.height * .47}>
        {
            props.children
        }
    </ScrollBox>
}


// WEBPACK FOOTER //
// ./src/_components/ScrollBox/index.jsx